import React from "react";
import ReactDOM from "react-dom";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import createHistory from "history/createBrowserHistory";
import { Route } from "react-router";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import {
  ConnectedRouter,
  routerReducer,
  routerMiddleware
} from "react-router-redux";

import theme from "./theme";

// Global CSS
import "./index.css";

// Reducers
import translator from "./reducers/translator";
import slack from "./reducers/slack";

// Containers
import TranslatorContainer from "./containers/TranslatorContainer";
import SlackContainer from "./containers/SlackContainer";

// Components
import Parent from "./components/Parent";
import Background from "./components/Background";
import AppViewPort from "./components/AppViewPort";
import Header from "./components/Header";
import AppWindowContentWrapper from "./components/AppWindowContentWrapper";
import PrivacyPolicy from "./components/PrivacyPolicy";
import DesktopMenu from "./components/DesktopMenu";

// Saga
import rootSaga from "./sagas/";

const history = createHistory();
const middleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  combineReducers({
    translator,
    slack,
    router: routerReducer
  }),
  applyMiddleware(middleware, sagaMiddleware, logger)
);

sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Parent>
          <DesktopMenu />
          <Background>
            <AppViewPort>
              <Route exact path="/*" component={Header} />
              <AppWindowContentWrapper>
                <Route exact path="/" component={TranslatorContainer} />
                <Route exact path="/privacy" component={PrivacyPolicy} />
                <Route exact path="/slack" component={SlackContainer} />
              </AppWindowContentWrapper>
            </AppViewPort>
          </Background>
        </Parent>
      </ConnectedRouter>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js